<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="indicators">2. Indicators</h2>
        <div v-if="loaded">
          Indicators section here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'Indicators',
        components: {},
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>